import React, { useEffect, useState } from "react";
import { Row, Col, Radio, DatePicker, Button, Descriptions } from "antd";
import Charts from "./chart";
import InspectionApi from "@api/inspectionnew";
import moment from "moment";
import { connect } from "react-redux";
const { RangePicker } = DatePicker;

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(({ userInfo }) => {
  let stationId = "-1";
  if (userInfo.stationIds) {
    userInfo.stationIds.includes(",")
      ? (stationId = userInfo.stationIds.split(",")[0])
      : (stationId = userInfo.stationIds);
  }
  const [dateType, setDateType] = useState(1);
  const [dataType, setDataType] = useState(1);
  const [time, setTime] = useState([moment(), moment()]);
  const [list, setList] = useState([]);
  const [chartData, setChartData] = useState({});

  useEffect(() => {
    getPatrolReport();
  }, [time]);

  useEffect(() => {
    if (dataType == 2) {
      const patrolnumberArr = [];
      const patrolitemnumberArr = [];
      const normalnumberArr = [];
      const abnormalnumberArr = [];
      const leaknumberArr = [];
      const xAxisData = [];
      list.length > 0 &&
        list.forEach((item) => {
          xAxisData.push(item.devicename);
          patrolnumberArr.push(item.patrolnumber);
          patrolitemnumberArr.push(item.patrolitemnumber);
          normalnumberArr.push(item.normalnumber);
          abnormalnumberArr.push(item.abnormalnumber);
          leaknumberArr.push(item.leaknumber);
        });
      setChartData(() => {
        return {
          xAxisData,
          patrolnumberArr,
          patrolitemnumberArr,
          normalnumberArr,
          abnormalnumberArr,
          leaknumberArr,
        };
      });
    }
  }, [dataType, list]);

  const changeDateType = (e) => {
    const value = e.target.value;
    setDateType(value);
    if (value == 1) {
      setTime([moment(), moment()]);
    } else if (value == 2) {
      setTime([moment().subtract(7, "day"), moment()]);
    } else if (value == 3) {
      setTime([moment().subtract(30, "day"), moment()]);
    }
  };

  const getPatrolReport = () => {
    const params = {
      startTime: time[0].format("YYYY-MM-DD") + " 00:00:00",
      endTime: time[1].format("YYYY-MM-DD") + " 23:59:59",
      stationId,
    };
    InspectionApi.getPatrolReport(params).then((res) => {
      if (res.status !== "0") return;
      res.data.forEach((item, index) => {
        item.key = index + 1;
      });
      setList(res.data);
    });
  };

  const changeDataType = (e) => {
    const value = e.target.value;
    setDataType(value);
  };

  const reset = () => {
    setDateType(1);
    setTime([moment(), moment()]);
  };

  return (
    <div style={{ padding: 20, background: "#fff" }}>
      <Row style={{ marginBottom: 40 }}>
        <Col span={2} offset={8}>
          <Radio.Group
            value={dataType}
            onChange={changeDataType}
            optionType="button"
            buttonStyle="solid"
          >
            <Radio.Button value={1}>列表</Radio.Button>
            <Radio.Button value={2}>图表</Radio.Button>
          </Radio.Group>
        </Col>
        <Col span={4}>
          <Radio.Group
            value={dateType}
            onChange={changeDateType}
            optionType="button"
            buttonStyle="solid"
          >
            <Radio.Button value={1}>日</Radio.Button>
            <Radio.Button value={2}>周</Radio.Button>
            <Radio.Button value={3}>月</Radio.Button>
          </Radio.Group>
        </Col>
        <Col span={6}>
          开始日期：
          <RangePicker value={time} onChange={(e) => setTime(e)} />
        </Col>
        <Col span={4}>
          <Button onClick={reset}>重置</Button>
          <Button
            type="primary"
            style={{ marginLeft: 10 }}
            onClick={getPatrolReport}
          >
            查询
          </Button>
        </Col>
      </Row>
      {dataType == 1 && (
        <>
          {list.map((item) => {
            return (
              <Descriptions title={item.devicename} key={item.key}>
                <Descriptions.Item label="巡检次数">
                  {item.patrolnumber}次
                </Descriptions.Item>
                <Descriptions.Item label="巡检项数量">
                  {item.patrolitemnumber}
                </Descriptions.Item>
                <Descriptions.Item label="正常">
                  {item.normalnumber}次
                </Descriptions.Item>
                <Descriptions.Item label="异常运行">
                  {item.abnormalnumber}次
                </Descriptions.Item>
                <Descriptions.Item label="漏检">
                  {item.leaknumber}次
                </Descriptions.Item>
              </Descriptions>
            );
          })}
        </>
      )}
      {dataType == 2 && <Charts data={chartData} height={500} />}
    </div>
  );
});
